/*
 * @Author: your name
 * @Date: 2022-03-14 10:32:33
 * @LastEditors: onepisYa
 * @LastEditTime: 2022-03-17 08:40:21
 * @Description: file content
 */

import request from "@/utils/request";

// 获取抽奖信息细节 根据 luckyAwardId 不同可能类型(大转盘 或者 抽奖)不同。
export function getPrizeList(params) {
  return request({
    url: "/product/lucky-award/h5/detail",
    method: "get",
    params,
  });
}
// 获取大转盘抽奖记录
export function getPrizeRecord(params) {
  return request({
    url: "/product/lucky-award/h5/big-wheel/record",
    method: "get",
    params,
  });
}
// 参与大转盘抽奖
export function joinBigWheel(params) {
  return request({
    url: "/product/lucky-award/take/out",
    method: "get",
    params,
  });
}

// 参与按时或按人数抽奖（非大转盘）
export function joinLuckyDraw(params) {
  return request({
    url: "/product/lucky-award/join",
    method: "get",
    params,
  });
}


// 按时或按人数抽奖记录查询（非大转盘）
export function getLuckyRecord(params) {
  return request({
    url: "/product/lucky-award/h5/record",
    method: "get",
    params,
  });
}